import { amPmConvertor } from "./timeConvertor";

export const timezoneList = {
    "-By IP Location-": "",
    "Pacific/Midway": "GMT - 11:00",
    "Pacific/Samoa": "GMT - 11:00",
    "Pacific/Honolulu": "GMT - 10:00",
    "US/Alaska": "GMT - 09:00",
    "US/Pacific": "GMT - 08:00",
    "America/Tijuana": "GMT - 08:00",
    "US/Arizona": "GMT - 08:00",
    "America/Chihuahua": "GMT - 07:00",
    "America/Mazatlan": "GMT - 07:00",
    "US/Mountain": "GMT - 07:00",
    "America/Managua": "GMT - 06:00",
    "US/Central": "GMT - 06:00",
    "America/Mexico City": "GMT - 06:00",
    "America/Monterrey": "GMT - 06:00",
    "Canada/Saskatchewan": "GMT - 06:00",
    "America/Bogota": "GMT - 05:00",
    "US/Eastern": "GMT - 05:00",
    "US/East-Indiana": "GMT - 05:00",
    "America/Lima": "GMT - 05:00",
    "Canada/Atlantic": "GMT - 04:00",
    "America/Caracas": "GMT - 04:30",
    "America/La Paz": "GMT - 04:00",
    "America/Santiago": "GMT - 04:00",
    "Canada/Newfoundland": "GMT - 03:30",
    "America/Sao Paulo": "GMT - 03:00",
    "America/Argentina/Buenos Aires": "GMT - 03:00",
    "America/Godthab": "GMT - 03:00",
    "America/Noronha": "GMT - 02:00",
    "Atlantic/Azores": "GMT - 01:00",
    "Atlantic/Cape Verde": "GMT - 01:00",
    "Africa/Casablanca": "GMT",
    "Etc/Greenwich": "GMT",
    "Europe/Lisbon": "GMT",
    "Europe/London": "GMT",
    "Africa/Monrovia": "GMT",
    "Europe/Amsterdam": "GMT",
    "Europe/Belgrade": "GMT",
    "Europe/Berlin'": "GMT",
    "Europe/Bratislava": "GMT + 01:00",
    "Europe/Brussels": "GMT + 01:00",
    "Europe/Budapest": "GMT + 01:00",
    "Europe/Copenhagen": "GMT + 01:00",
    "Europe/Ljubljana": "GMT + 01:00",
    "Europe/Madrid": "GMT + 01:00",
    "Europe/Paris": "GMT + 01:00",
    "Europe/Prague": "GMT + 01:00",
    "Europe/Rome": "GMT + 01:00",
    "Europe/Sarajevo": "GMT + 01:00",
    "Europe/Skopje": "GMT + 01:00",
    "Europe/Stockholm": "GMT + 01:00",
    "Europe/Vienna": "GMT + 01:00",
    "Europe/Warsaw": "GMT + 01:00",
    "Africa/Lagos": "GMT + 01:00",
    "Europe/Zagreb": "GMT + 01:00",
    "Europe/Athens": "GMT + 02:00",
    "Europe/Bucharest": "GMT + 02:00",
    "Africa/Cairo": "GMT + 02:00",
    "Africa/Harare": "GMT + 02:00",
    "Europe/Helsinki": "GMT + 02:00",
    "Europe/Istanbul": "GMT + 02:00",
    "Asia/Jerusalem": "GMT + 02:00",
    "Africa/Johannesburg": "GMT + 02:00",
    "Europe/Riga": "GMT + 02:00",
    "Europe/Sofia": "GMT + 02:00",
    "Europe/Tallinn": "GMT + 02:00",
    "Europe/Vilnius": "GMT + 02:00",
    "Europe/Moscow": "GMT + 03:00",
    "Asia/Baghdad": "GMT + 03:00",
    "Asia/Kuwait": "GMT + 03:00",
    "Europe/Minsk": "GMT + 03:00",
    "Africa/Nairobi": "GMT + 03:00",
    "Asia/Riyadh": "GMT + 03:00",
    "Europe/Volgograd": "GMT + 03:00",
    "Asia/Tehran": "GMT + 03:30",
    "Asia/Muscat": "GMT + 04:00",
    "Asia/Baku": "GMT + 04:00",
    "Asia/Dubai": "GMT + 04:00",
    "Asia/Tbilisi": "GMT + 04:00",
    "Asia/Yerevan": "GMT + 04:00",
    "Asia/Kabul": "GMT + 04:30",
    "Asia/Karachi": "GMT + 05:00",
    "Asia/Tashkent": "GMT + 05:00",
    "Asia/Calcutta": "GMT + 05:30",
    "Asia/Kolkata": "GMT + 05:30",
    "Asia/Katmandu": "GMT + 05:45",
    "Asia/Almaty": "GMT + 06:00",
    "Asia/Dhaka": "GMT + 06:00",
    "Asia/Yekaterinburg": "GMT + 06:00",
    "Asia/Rangoon": "GMT + 06:30",
    "Asia/Bangkok": "GMT + 07:00",
    "Asia/Jakarta": "GMT + 07:00",
    "Asia/Novosibirsk": "GMT + 07:00",
    "Asia/Hong Kong": "GMT + 08:00",
    "Asia/Chongqing": "GMT + 08:00",
    "Asia/Krasnoyarsk": "GMT + 08:00",
    "Asia/Kuala Lumpur": "GMT + 08:00",
    "Australia/Perth": "GMT + 08:00",
    "Asia/Singapore": "GMT + 08:00",
    "Asia/Taipei": "GMT + 08:00",
    "Asia/Ulan Bator": "GMT + 08:00",
    "Asia/Urumqi": "GMT + 08:00",
    "Asia/Irkutsk": "GMT + 09:00",
    "Asia/Tokyo": "GMT + 09:00",
    "Asia/Seoul": "GMT + 09:00",
    "Australia/Adelaide": "GMT + 09:30",
    "Australia/Darwin": "GMT + 09:30",
    "Australia/Brisbane": "GMT + 10:00",
    "Australia/Canberra": "GMT + 10:00",
    "Pacific/Guam": "GMT + 10:00",
    "Australia/Hobart": "GMT + 10:00",
    "Australia/Melbourne": "GMT + 10:00",
    "Pacific/Port Moresby": "GMT + 10:00",
    "Australia/Sydney": "GMT + 10:00",
    "Asia/Yakutsk": "GMT + 10:00",
    "Asia/Vladivostok": "GMT + 11:00",
    "Pacific/Auckland": "GMT + 12:00",
    "Pacific/Fiji": "GMT + 12:00",
    "Pacific/Kwajalein": "GMT + 12:00",
    "Asia/Kamchatka": "GMT + 12:00",
    "Asia/Magadan": "GMT + 12:00",
    "Pacific/Tongatapu": "GMT + 13:00",
};

export const sortedKeys = Object.keys(timezoneList).sort(function (a, b) {
    const textA = a.toUpperCase();
    const textB = b.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
});

export const getComppletedString = (
    customValue: string,
    isLocationActive: boolean,
    isTextEdited: boolean,
    defaultValue: string,
) => {
    if (isTextEdited) return defaultValue;

    return customValue.includes("(") && customValue.includes(")")
        ? customValue
        : isLocationActive
        ? customValue
        : customValue + "(" + getDataByKey(customValue) + ")" + getTimeByTimezone(getDataByKey(customValue));
};

const convertByAdd = (utcHours: string, utcMinutes: string, addHours: string, addMinutes: string) => {
    let resultHours;
    let resultMinutes;
    let format;
    let addedHours = +utcHours + +addHours;
    let addedMinutes = +utcMinutes + +addMinutes;

    if (addedMinutes > 60) {
        addedHours++;
        resultMinutes = addedMinutes - 60;
    } else resultMinutes = addedMinutes;

    if (addedHours > 24) {
        resultHours = addedHours - 24;
    } else resultHours = addedHours;

    resultHours = resultHours.toString().length < 2 ? "0" + resultHours : `${resultHours}`;
    resultMinutes = resultMinutes.toString().length < 2 ? "0" + resultMinutes : `${resultMinutes}`;
    if (+resultHours > 12) {
        format = "PM";
    } else format = "AM";
    resultHours = amPmConvertor(resultHours, format);
    return `${resultHours}:${resultMinutes} ${format}`;
};

const convertByMinus = (utcHours: string, utcMinutes: string, minusHours: string, minusMinutes: string) => {
    let resultHours;
    let resultMinutes;
    let format;
    let deducatedHours = +utcHours - +minusHours;
    let deducatedMinutes = +utcMinutes - +minusMinutes;

    if (deducatedMinutes < 0) {
        deducatedHours--;
        resultMinutes = Math.abs(deducatedMinutes);
    } else resultMinutes = deducatedMinutes;

    if (deducatedHours < 0) {
        resultHours = Math.abs(deducatedHours);
    } else resultHours = deducatedHours;
    resultHours = resultHours.toString().length < 2 ? "0" + resultHours : `${resultHours}`;
    resultMinutes = resultMinutes.toString().length < 2 ? "0" + resultMinutes : `${resultMinutes}`;
    if (+resultHours > 12) {
        format = "PM";
    } else format = "AM";
    resultHours = amPmConvertor(resultHours, format);
    return `${resultHours}:${resultMinutes} ${format}`;
};

export const getTimeByTimezone = (timezoneGTM: string) => {
    const utcTime = new Date().toUTCString().split(" ")[4];
    const [utcHours, utcMinutes] = utcTime.split(":");
    if (timezoneGTM.length < 6) return `${utcHours}:${utcMinutes} ${+utcHours > 12 ? "PM" : "AM"}`;
    const [, operator, value] = timezoneGTM.split(" ");
    const [hours, minutes] = value.split(":");
    let showTime = "";
    switch (operator) {
        case "+":
            showTime = convertByAdd(utcHours, utcMinutes, hours, minutes);
            break;
        case "-":
            showTime = convertByMinus(utcHours, utcMinutes, hours, minutes);
            break;
        default:
            showTime = `${utcHours}:${utcMinutes}`;
    }
    return showTime;
};

export const getDataByKey = (key: string) => {
    //@ts-ignore
    return timezoneList[`${key}`] || "";
};

export const logicTimeZonesList = sortedKeys.slice(1).reduce(
    (acc, current) => ({
        ...acc,
        //@ts-ignore
        [current + timezoneList[current]]: current + timezoneList[current],
    }),
    {},
);
